import TextField from "@mui/material/TextField";

import i18n from "../../../../../constants/i18n";
import getKhattabatMatchingStore from "../../../../../stores/khattabat-stores/matching-stores";
import getKhattabat101MGeneralStore from "../../../../../stores/khattabat-stores/101m-stores/general-101m-store";
import { withLiteObserverAndTheme } from "../../../../../core/et3-enhanced-render";
import { khattabaConversationParsing } from "../../../../../helpers/et3-conversation-parse";

const MessageToSend = withLiteObserverAndTheme(() => {
  const isArabicMatchAppLanguage = getKhattabatMatchingStore()
    .matchAppLanguage.get()
    .some((row) => row.value === "AR");

  return (
    <TextField
      multiline
      fullWidth
      minRows={4}
      defaultValue={getKhattabat101MGeneralStore().messageToSendToCreated101M.get()}
      placeholder={i18n.get("SEND_ONE_O_ONE_M_MESSAGE_PLACE_HOLDER")}
      onChange={(event) =>
        getKhattabat101MGeneralStore().setMessageToSendToCreated101M(
          khattabaConversationParsing(event.target.value)
        )
      }
      slotProps={{
        htmlInput: { dir: isArabicMatchAppLanguage ? "rtl" : "ltr" }
      }}
    />
  );
});

export default MessageToSend;
